<template>
  <div>
    <div id="bom-uploadr">
      <Upload
          type="drag"
          :action="target"
          :headers="headers"
          :before-upload="handleBeforeUpload"
          :on-format-error="handleFormatError"
          :on-success="handleSuccess"
          :accept="accept"
          :show-upload-list="false">
          <div style="padding: 50px 0">
              <Icon type="ios-cloud-upload" size="52"></Icon>
              <p>{{ $t('bom_tool.edit.upload.tip') }}</p>
          </div>
      </Upload>
      <Spin size="large" fix v-show="uploading"></Spin>
    </div>
    <Dropdown trigger="click" style="float: left" placement="bottom-start">
        <a href="javascript:void(0)">
            {{ $t('bom_tool.edit.upload.advenced') }}
            <Icon type="ios-arrow-down"></Icon>
        </a>
        <DropdownMenu slot="list" style="padding: 5px 10px">
            {{ $t('bom_tool.edit.upload.header_row') }}<br>
            <InputNumber :min="1" :step="1" :precision="0" size="small" :disabled="uploading" v-model="headerRowIndex" id="header-row-input"></InputNumber>
        </DropdownMenu>
    </Dropdown>
    <div class="text-align-right">
      <Button style="margin-right: 5px;" @click="handleSkip" replace>{{ $t('bom_tool.edit.upload.skip') }}</Button>
      <Button type="primary" disabled>{{ $t('bom_tool.edit.upload.next') }} <Icon type="ios-arrow-forward"></Icon></Button>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import config from '@/config'
import { getToken } from '@/libs/util'
export default {
  name: 'BomUploader',
  data () {
    return {
      uploaded: false,
      uploading: false,
      accept: '.csv, .xlsx, .xls',
      maxNum: 1,
      target: this.$config.baseUrl + 'files/upload',
      headers: {
        Accept: config.http.headers.Accept,
        Authorization: 'Bearer ' + getToken()
      },
      headerRowIndex: 1
    }
  },
  methods: {
    ...mapActions([
      'createCustomerBomFile'
    ]),
    setTargetUrl () {
      this.target = this.$config.baseUrl + 'files/upload'
    },
    handleSkip () {
      this.$router.replace({
        name: 'menu.bom.view',
        params: {
          bomId: this.$route.query.rootBomId || this.$route.params.bomId
        },
        query: {
          rootBomId: this.$route.query.rootBomId || this.$route.params.bomId
        }
      })
    },
    handleBeforeUpload (file, fileList) {
      if (!file) {
        return false
      }
      this.uploading = true

      if (fileList && fileList.length >= this.maxNum) {
        this.$Notice.warning('Reach max number of uploads.')
        return false
      }

      if (this.fileValidateCallback && !this.fileValidateCallback(file)) {
        return false
      }

      this.currentFile = file
    },
    handleFormatError (file, fileList) {
      this.uploading = false
      this.$Notice.error({
        title: this.$t('notice.error'),
        desc: this.$t('Invalid file format. The accepted file extensions are: ' + this.accept)
      })
    },
    async handleSuccess (fileManaged, file, fileList) {
      this.$emit('on-success', fileManaged, this.currentFile)
      let data = await this.createCustomerBomFile({
        bomId: (this.$route.query.rootBomId || this.$route.params.bomId),
        fileId: fileManaged.id,
        headerRowIndex: this.headerRowIndex
      })
      this.uploading = false
      this.uploaded = true
      if (data.headers.length < 5) {
        this.$Notice.error({
          title: this.$t('bom_tool.edit.error.length'),
          desc: this.$t('bom_tool.edit.error.return')
        })
      } else {
        this.uploading = true
        this.$router.replace({
          name: 'menu.bom.upload_map',
          params: {
            bomId: this.$route.query.rootBomId || this.$route.params.bomId
          },
          query: {
            rootBomId: this.$route.query.rootBomId || this.$route.params.bomId,
            customerBomFileId: data.id
          }
        })
      }
    }
  }
}
</script>

<style lang="less">
#bom-uploadr {
  position: relative;
  margin-bottom: 15px;
}
#bom-tool {
  overflow: visible;
}
#header-row-input {
  width: 100px;
  margin-top: 5px;
}
</style>
